<template>
	<div class="productstation">
		<div class="imgbox" v-for="item in listdata" v-show="activename == item.name">
			<img v-for="i in item.images" :src="i.url" alt="">
		</div>
	</div>
</template>

<script>
	import global from '../common/global.js'
	export default {
		name: 'Productstation',
		mounted() {
			this.activename = this.$route.query.globalname
			// console.log("globalname", this.activename)
			this.tra(this.activename)

			document.title = this.chinese //改标题名称
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}

		},
		methods: {
			tra(e) {
				let that = this		
				for( let i = 0 ;  i < that.listdata.length;i++) {
					if (that.listdata[i].name == e) {
						that.chinese = that.listdata[i].chinesename
					}
				}

			}
		},
		// onload(option) {

		// 	this.$route.query.setid
		// 	console.log(option.globalname); //打印出上个页面传递的参数。

		// },
		data() {
			return {
				activename: '',
				chinese: '',
				listdata: [{
						name: 'desk',
						chinesename: '乐班电动电脑升降台',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/7.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/8-1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/8-2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/9-1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/9-2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/desk/27.jpg',
							},
						]
					}, {
						name: 'kaobei',
						chinesename: '乐班人体工学可调靠背',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/7.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/11.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaobei/28.jpg',
							},
						]
					},
					{
						name: 'cappa',
						chinesename: '乐范3D揉捏按摩披肩',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/7.gif',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/28.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/cappa/33.jpg',
							},
						]
					}, {
						name: 'jingzhen',
						chinesename: '乐范按摩助眠颈枕',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/7.gif',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/28.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/35.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/jingzhen/36.jpg',
							},
						]
					}, {
						name: 'yidian',
						chinesename: '乐范背部按摩椅垫',
						
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/8.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/16.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/28.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/35.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/36.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/yidian/37.jpg',
							},
						]
					}, {
						name: 'zuodian',
						chinesename: '乐班护腰塑形坐垫',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/8.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/16.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/20.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/28.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zuodian/30.jpg',
							},

						]
					},
					{
						name: 'foot',
						chinesename: '乐范脚部揉捏按摩器',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/8.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/9.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/11.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/16.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/20.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/foot/28.jpg',
							},

						]
					}, {
						name: 'molitie',
						chinesename: '乐范随身魔力按摩贴',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/34.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/35.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/molitie/36.jpg',
							},

						]
					}, {
						name: 'kaozhen',
						chinesename: '乐范揉捏按摩靠枕',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/9.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/9-1.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/28.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/35.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/36.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/37.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/38.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/39.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/40.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/41.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/42.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/43.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/44.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/45.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/kaozhen/46.jpg',
							},
						]
					}, {
						name: 'hand',
						chinesename: '乐范无线手持按摩棒',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/hand/32.jpg',
							}

						]
					}, {
						name: 'uxingzhen',
						chinesename: '乐范双弹力透气U型枕',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/4.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/10.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/uxingzhen1/12.jpg',
							}

						]
					}, {
						name: 'siqu',
						chinesename: '乐范四驱魔力按摩贴',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/4.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/5.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/24.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/32.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/35.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/36.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/37.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/38.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/39.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/40.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/41.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/siqu/42.jpg',
							}

						]
					}, {
						name: 'qiyaleg',
						chinesename: '乐范腿部气压按摩器',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/7.gif',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/qiyaleg/31.jpg',
							}

						]
					}, {
						name: 'beikao',
						chinesename: '乐班人体工学可调靠背',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/beikao/35.jpg',
							}

						]
					}, {
						name: 'warm',
						chinesename: '乐范魔力贴温情版',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/7.gif',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/32.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/35.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/36.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/warm/37.jpg',
							}

						]
					}, {
						name: 'meituiyi',
						chinesename: '乐范无限按摩美腿仪',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/7.gif',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/meituiyi/32.jpg',
							},


						]
					}, {
						name: 'zhua',
						chinesename: '乐范小摩爪按摩器',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/2-1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/2-2.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/2-3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/2-4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/9.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/zhua/20.jpg',
							},


						]
					}, {
						name: 'coldhot',
						chinesename: '乐范眼部冷热按摩仪',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/12.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/32.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/35.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/coldhot/36.jpg',
							},


						]
					}, {
						name: 'lingmou',
						chinesename: '乐范灵眸眼部按摩仪',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/8.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/13.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/32.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/lingmou/35.jpg',
							},

						]
					},  {
						name: 'egg',
						chinesename: '乐范小魔蛋趣味按摩仪',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/6.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/18.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/24.gif',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/25.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/26.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/27.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/28.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/29.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/30.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/31.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/32.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/33.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/34.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/egg/35.jpg',
							},

						]
					}, {
						name: 'chair',
						chinesename: '乐范一维AI智能按摩椅',
						images: [{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/1.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/2.jpg',
							}, {
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/3.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/4.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/5.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/6.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/7.jpg',
							},

							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/8.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/9.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/10.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/11.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/12.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/13.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/14.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/15.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/16.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/17.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/18.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/19.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/20.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/21.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/22.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/23.jpg',
							},
							{
								url: this.GLOBAL.imgHost + '/images/Productstation/chair/24.jpg',
							}


						]
					}
				]

			}
		},
		components: {

		},
	}
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	.productstation {
		width: 65.5rem;
		margin: 0 auto;
		/* border: #000066 solid; */
	}

	.productstation .imgbox {
		width: 100%;
		margin: 0 a;
		font-size: 0;
		/* border: yellow solid; */
	}

	.productstation .imgbox img {
		width: 100%;
		/* border: #006600 solid; */
	}
</style>
